import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    OnDestroy,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {IrbEditor} from '@irb/irb-editors/irb-editors.base';
import {IEvent, IrbAppEvents, IrbModelsEvents} from '@irb-common/events';
import {EditorMmcModelService} from '@irb/irb-editors/editor-mmc-model/editor-mmc-model.service';
import {DatePipe} from '@angular/common';
import {EasternTimePipe} from '@irb-common/pipes/EasternTimePipe';
import {formatNumber} from '@angular/common';
import {IAlertDialogData, IUserDetails} from '@irb/app.model';
import {DialogComponent} from '@irb-common/components/dialog/dialog.component';
import {Subscription} from 'rxjs';
import {MmcInventoryService} from '@irb/irb-models/model-market-center/mmc-inventory/mmc-inventory.service';
import { IrbFooterDialogEvents } from '@irb/irb-common/components/footer/IrbFooterDialogEvents';
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import {
    MmcInventoryActionsService
} from "@irb/irb-models/model-market-center/mmc-inventory/mmc-inventory-actions.service";


@Component({ standalone: false,
    selector: 'irb-editor-mmc-advisor-model',
    templateUrl: './editor-mmc-advisor-model.component.html',
    styleUrls: ['./editor-mmc-advisor-model.component.scss', '../../../irb-common/styles/dialog.scss', '../../editor-sidebar/editor-sidebar.component.scss'],
    providers: [DatePipe, EasternTimePipe,IrbEditorsService],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class EditorMmcAdvisorModelComponent extends IrbEditor implements OnDestroy {

    @ViewChild('body') body: ElementRef;

    @ViewChild("dialog") dialog: DialogComponent;

    defaultExpandedPanels: Array<string> = ["OVERVIEWDOCUMENTS", "MMCADVISORSECURITYALLOCATION", "MMCADVISORSECURITYALLOCATIONCHART", "MMCADVISORMODELOVERVIEW", "MMCADVISORPERFORMANCE", "MMCADVISORBACKCOST"];
    identifier: string;
    eventData: any;
    modelData: any;
    modelNote: string = '';
    private originalNote: string = '';
    prevNextModelIdx: number = 0;
    securityList: any;
    subGoPaid: Subscription;
    subGoSubscribe: Subscription;
    saveDisabled: boolean = true;
    isShowManagerDisclosure: boolean = false;
    isShowDisclosureOnModelDetails: boolean = false;
    userDetails: any;
    isUiTest = false;
    progressTimer: any;

    constructor(private editorMmcModelService: EditorMmcModelService,
                private mmcInventoryService: MmcInventoryService,
                public localEditorService: IrbEditorsService,
                private datePipe: DatePipe, private easternTimePipe: EasternTimePipe,
                public ats: AnalyticsService,
                private mmcInventoryActionsService: MmcInventoryActionsService) {
        super();
        this.identifier = 'modelMarketId';
    }

    get(event: IEvent) {
        super.get(event);
        this.eventData = event.data;
        this.modelData = event.data && event.data.data;
        this.ats.trackModelMarketCenterDetailEvent();
        this.localEditorService.loadExpansionState(this.defaultExpandedPanels.length, "editor-model", this.defaultExpandedPanels);
        this.securityList = null;

        this.saveDisabled = true;
        if (this.modelData) {
            if(this.eventData.readOnlyView !== undefined && this.eventData.readOnlyView === true) {
                this.getDataByModelMarketId(this.modelData.modelMarketId);
            } else {
                this.formatValues();
                this.prevNextModelIdx = event.data.rowIndex || 0;
                const sortField = event.data.sortField;
                const filter = event.data.filter;
                this.getDataByIndex(this.prevNextModelIdx, sortField, filter);
            }
        }

        this.load({});
        this.getRoles();
    }

    ngOnDestroy() {
        if (this.subGoPaid) {
            this.subGoPaid.unsubscribe();
        }
        if (this.subGoSubscribe) {
            this.subGoSubscribe.unsubscribe();
        }
        if (this.progressTimer)
            clearTimeout(this.progressTimer);

        super.ngOnDestroy();
    }
    get isFirstModel(): boolean {
        return this.prevNextModelIdx === 0;
    }

    get isLastModel(): boolean {
        return this.prevNextModelIdx === this.eventData.rowCount - 1;
    }
    getPreviousModel(): void {
        this.checkForModifications(() => {
            this.prevNextModelIdx--;
            this.goToModel();
        });
    }
    getNextModel(): void {
        this.checkForModifications(() => {
            this.prevNextModelIdx++;
            this.goToModel();
        });
    }
    goToModel(): void {
        const self = this;
        if (self.prevNextModelIdx <= 0) {
            self.prevNextModelIdx = 0;
        }
        if (this.prevNextModelIdx > self.eventData.rowCount - 1) {
            this.prevNextModelIdx = self.eventData.rowCount - 1;
        }
        const sortField = self.eventData.sortField;
        const filter = self.eventData.filter;
        this.getDataByIndex(self.prevNextModelIdx, sortField, filter);
    }
    getAdvisorNote(modelMarketId: any) {
        this.editorMmcModelService.getAdvisorNote(modelMarketId).subscribe((response: any) => {
            if (response.success && response.data) {
                this.modelNote = response.data.note ? response.data.note.trim() : '';
                this.originalNote = response.data.note ? response.data.note.trim() : '';
            }
        });
    }
    validateNoteChange() {
        this.saveDisabled = this.modelNote.trim() === this.originalNote;
    }

    setAdvisorNote() {
        const params: any = {
            modelMarketId: this.modelData.modelMarketId,
            note: this.modelNote.trim()
        };
        this.editorMmcModelService.saveAdvisorNote(params).subscribe((response: any) => {
            if (response.success) {
                this.originalNote = this.modelNote.trim();
                this.saveDisabled = true;
            }
        });
    }

    getDataByIndex(idx: number, sortField?: string, filter?: string) {
        this.isUiTest = true;
        this.editorMmcModelService.getAdvisorModelDetail(idx, sortField, filter).subscribe((response: any) => {
            this.processDetailData(response);
        });
    }
    getDataByModelMarketId(modelMarketId: any) {
        this.isUiTest = true;
        this.editorMmcModelService.getAdvisorModelDetailByModelMarketId(modelMarketId).subscribe((response: any) => {
            this.processDetailData(response);
        });
    }
    processDetailData(response: any) {
        if (response.success) {
            this.modelData = response.data;
            this.getAdvisorNote(this.modelData.modelMarketId);
            this.securityList = this.modelData.securityList;
            this.isUiTest = false;
            this.formatValues();

            if (this.modelData && this.modelData.modelProvider) {
                this.isShowDisclosureOnModelDetails = this.modelData.modelProvider.firmDisclosureText.length > 0
                this.modelData.firmDisclosureRequired = this.modelData.modelProvider.firmDisclosureRequired;
                this.modelData.modelProviderId = this.modelData.modelProvider.firmId;
                this.isShowManagerDisclosure = this.modelData.modelProvider.firmDisclosureRequired && this.modelData.modelProvider.firmDisclosureText.length > 0;
            }
        }
    }
    load(detailData: any) {
        super.load(detailData);

        if (this.modelData && this.modelData.modelProvider) {
            this.isShowManagerDisclosure = this.modelData.modelProvider.firmDisclosureRequired && this.modelData.modelProvider.firmDisclosureText.length > 0;
        }

        setTimeout(() => this.onResize());
    }

    private formatValues() {
        if (this.modelData) {
            this.modelData.used_for = this.formatUsedFor(this.modelData.usedFor);
            this.modelData.allocation_changes = this.formatAllocationChanges(this.modelData.allocationChanges);
            this.modelData.sociallyResponsible = this.formatBooleanToYesNo(this.modelData.isSociallyResponsible);
            this.modelData.bbStyle = this.titleCaseFormatter(this.modelData.buildingBlockStyle);
            this.modelData.turnover = this.formatPercentage(this.modelData.turnover);
            this.modelData.weightedYield = this.formatPercentage(this.modelData.weightedYield, 2);
            this.modelData.finscore = this.modelData.finscore ? this.modelData.finscore : '--';
            this.modelData.modifiedDate = this.modelData.publishOrAllocationUpdatedDate ? this.datePipe.transform(this.easternTimePipe.transform(this.modelData.publishOrAllocationUpdatedDate), "MM/dd/yyyy") : '--';
            this.modelData.performanceasof = this.modelData.performanceAsOf ? this.datePipe.transform(this.easternTimePipe.transform(this.modelData.performanceAsOf), "MM/dd/yyyy") : '--';
            this.modelData.inceptionDate = this.modelData.inceptionDate ? this.datePipe.transform(this.easternTimePipe.transform(this.modelData.inceptionDate), "MM/dd/yyyy") : '--';
            this.modelData.gips_compliant = this.formatBooleanToYesNo(this.modelData.gipsCompliant);
            this.modelData.me = this.formatPercentage(this.modelData.me, 2);
            this.modelData.t3 = this.formatPercentage(this.modelData.t3, 2);
            this.modelData.ytd = this.formatPercentage(this.modelData.ytd, 2);
            this.modelData.t12 = this.formatPercentage(this.modelData.t12, 2);
            this.modelData.yr3 = this.formatPercentage(this.modelData.yr3, 2);
            this.modelData.yr5 = this.formatPercentage(this.modelData.yr5, 2);
            this.modelData.yr10 = this.formatPercentage(this.modelData.yr10, 2);
            this.modelData.rorInception = this.formatPercentage(this.modelData.rorInception, 2);
            this.modelData.weightedNetExpenseRatio = this.formatPercentage(this.modelData.weightedNetExpenseRatio, 2);
            this.modelData.suggestedMinimum = !this.modelData.suggestedMinimum ? '--' : '$' + formatNumber(this.modelData.suggestedMinimum, "en-us");
            this.modelData.estimatedTransactionFee = !this.modelData.estimatedTransactionFee ? '--' : '$' + formatNumber(this.modelData.estimatedTransactionFee, "en-us", "1.2-2");
            if (this.modelData.modelProvider) {
                this.modelData.firmFoundedDate = this.modelData.modelProvider.firmFoundedDate ? this.modelData.modelProvider.firmFoundedDate : '';
                this.modelData.aum = !this.modelData.modelProvider.assetsUnderManagement ? '--' : '$' + formatNumber(this.modelData.modelProvider.assetsUnderManagement, "en-us");
                this.modelData.firmWebsite = this.modelData.modelProvider.firmWebsite;
                this.modelData.firmPhone = this.modelData.modelProvider.firmPhone ? this.modelData.modelProvider.firmPhone : '--';
                this.modelData.firmEmail = this.modelData.modelProvider.firmEmail ? this.modelData.modelProvider.firmEmail : '--';
            }
            this.modelData.taxManaged = this.modelData.usedFor === 'custom' ? '--' : this.formatBooleanToYesNo(this.modelData.isTaxManaged);
            this.modelData.modelProviderName = this.modelData.modelProviderName || this.modelData.modelProvider.firmName;
            this.modelData.costBPs = this.modelData.usedFor === 'custom' ? '--' : this.modelData.costBPs + ' BPS';
        }
    }


    formatAllocationChanges(s: string) {
        let retVal: string = '';
        switch (s) {
            case "NEVER":
                retVal = "Never";
                break;
            case "ANNUALLY":
                retVal = "+/- Annually";
                break;
            case "QUARTERLY":
                retVal = "+/- Quarterly";
                break;
            case "MONTHLY":
                retVal = "+/- Monthly";
                break;
            case "CONTINUOUS":
                retVal = "Continuous/as needed";
                break;
            case "NONE":
                retVal = "None";
                break;
            default:
                retVal = "";
        }
        return retVal;
    }

    formatUsedFor(s: string) {
        if (!s) return '';
        let retVal: string = '';
        switch (s.toUpperCase()) {
            case "CSTRATEGY":
                retVal = "Complete Strategy";
                break;
            case "SLEEVE":
                retVal = "Sleeve";
                break;
            case "INCOME":
                retVal = "Income";
                break;
            case "CUSTOM":
                retVal = "custom";
                break;
            default:
                retVal = "";
        }
        return retVal;
    }

    private formatBooleanToYesNo(v: any) {
        if (v == null || v === -1)
            return '--';
        return v ? 'Yes' : 'No';
    }

    private titleCaseFormatter(s: string) {
        if (!s) return '';
        return s.substring(0, 1).toUpperCase() + s.substring(1);
    }

    private formatPercentage(number: number, places?: number) {
        let classes: any = [];
        if (isNaN(number) || number == null) {
            return "--";
        } else {
            if (number < 0) {
                classes.push("red");
            }

            if (typeof places !== "undefined") {
                return number.toFixed(places) + "%";
            } else {
                return "<span class='" + classes.join(" ") + "'>" + number + "%</span>";
            }
        }
    }

    getFinMasonFinScoreTT() {
        return this.ies.finMansonTooltip();
    }

    subscribe() {
        this.ats.trackClickEvent("lc_subscribe");
        this.mmcInventoryActionsService.goBlendAfterSubscribe = false;
        this.mmcInventoryActionsService.goExistedBlendAfterSubscribe = false;
        this.mmcInventoryActionsService.editSlideSlot = this.slot;
        this.mmcInventoryActionsService.subscribeFlowStart([this.modelData]);
    }

    showMMCFooterDialog() {
        this.as.fireEvent(IrbFooterDialogEvents.SHOW_MMC_FOOTER_DIALOG);
    }


    checkForManagerDisclosure() {
        const msg = "<div class='block'><strong>" + this.modelData.modelProvider.firmName + " " + "Disclosures</strong></div><div style='max-height: 300px; overflow-y: auto'>" + this.modelData.modelProvider.firmDisclosureText + "</div>";
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dTitle: "Model Manager and Advisor Disclosure",
            altMsgHTML: msg,
            dProceedBtnLabel: "Close",
        } as IAlertDialogData);
    }

    private getRoles() {
        this.userDetails = this.as.getItem('IRB_APP_CONFIG') as IUserDetails || {};
    }

    download_adv() {
        this.ats.trackClickEvent("lc_mmc_ft_adv");
    }

}
